import {Injectable} from '@angular/core';
import { Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class CardScannerService {
    private URL = environment.baseURL + environment.apiEndpoint + environment.apiVersion;
    private IMAGE_SUMMARIZE_ENDPOINT = '/lead/image-summarize/';

    constructor(protected http: HttpClient) {}

    private buildUrl() {
        return this.URL + this.IMAGE_SUMMARIZE_ENDPOINT;
    }

    // POST request when uploading image (FormData) to get summarization of the image
    summarizeImageFromFile(file: File): Observable<any> {
        const summarizeFormData = new FormData();
        summarizeFormData.append('image', file);

        return this.http.post(this.buildUrl(), summarizeFormData).pipe();
    }
}
